import React from 'react';
import PropTypes from 'prop-types';
import { InvoiceWorkqueue } from './InvoiceWorkqueue';
import { DRAFT_CBO_ADMIN_STATUSES, INVOICE_WQ_BULK_ACTIONS } from '../constants';
import { NoInvoicesFoundCard } from '../components';

const DraftInvoices = ({ children }) => (
  <InvoiceWorkqueue
    defaultBulkActions={INVOICE_WQ_BULK_ACTIONS.draft.default}
    cboStatuses={DRAFT_CBO_ADMIN_STATUSES}
    renderNoInvoicesFound={({ isFiltered, resetFilters }) => (
      <NoInvoicesFoundCard isFiltered={isFiltered} status="draft" resetFilters={resetFilters} />
      )}
    showInvoiceAging
    pageName="Draft"
    path="draft/"
  >
    {children}
  </InvoiceWorkqueue>
  );

DraftInvoices.propTypes = {
  children: PropTypes.node,
};

DraftInvoices.defaultProps = {
  children: undefined,
};
export default DraftInvoices;
